import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import CritOpts from 'app/components/company-admin/grant-system/rubric/crit-opts';
import helpers  from 'app/helpers/rubrics';

const {formatWeight, OptionStyles} = helpers;
const defaultStyle = OptionStyles.BLUE;

const getCritProps = (crit) => {
  const label = crit.label || crit.value;
  const value = crit.label ? null : crit.value;
  const style = crit.style || defaultStyle;
  return {label, value, style}
};

class RubricScore extends React.PureComponent {

  render() {
    const {score, className} = this.props;
    if (!score) return null;
    const crits = Object.values(score.crits || {});
    const hasMany = crits.length > 1;
    const isSingle = crits.length === 1;
    const first = crits[0];
    const mainProps = {
      label: score.label || (isSingle ? (first.label || first.value) : score.absolute),
      value: isSingle ? null : formatWeight(score.percent, 1),
      style: score.style || (isSingle ? (first.style || defaultStyle) : defaultStyle),
    };
    const showCrits = _.orderBy(hasMany ? crits : [], 'sortIndex', 'asc');
    const manyClass = hasMany ? 'many' : 'single';

    return (
      <div className={`rub-score ${className} ${manyClass}`}>
        {/* <CritOpts.Single canChange={false} {...mainProps} size="regular" selected /> */}
        {showCrits.map((crit, i) => {
          return (
            <div className="rub-score-crit" key={i}>
              <div className="rub-score-crit-label">{crit.title}</div>
              <CritOpts.Single canChange={false} className="rub-score-crit-chip" {...getCritProps(crit)} size="xs" selected />
            </div>
          );
        })}
        <div className="rub-score-crit main">
          <div className="rub-score-crit-label">{hasMany ? 'Weighted Score' : 'Result'}</div>
          <CritOpts.Single canChange={false} className="rub-score-crit-chip" {...mainProps} size="small" selected />
        </div>
      </div>
    );
  }

}

RubricScore.propTypes = {
  score: PropTypes.object,
  className: PropTypes.string,
};

RubricScore.defaultProps = {
  score: null,
  className: '',
};

export default RubricScore;
